import { ListItem, makeStyles } from '@rneui/themed'
import React, { useState } from 'react'
import { FlatList, View } from 'react-native'
import { SafeAreaView } from 'react-native-safe-area-context'
import { SettingValue } from 'settings/types'
import { CheckBox } from 'shared/components/check_box'
import { PressableOpacity } from 'shared/components/pressable_opacity'
interface Props {
  selectedIds: string[]
  values: SettingValue[]
  onSelectValue(selectedIds: string[]): void
}

export function MultiSelectSettingView(props: Props) {
  const styles = useStyles()
  const [selectedIds, setSelectedIds] = useState(props.selectedIds)

  function onSelectValue(value: SettingValue) {
    const newSelectedIds = selectedIds.includes(value.id)
      ? selectedIds.filter(id => id !== value.id)
      : [...selectedIds, value.id]

    setSelectedIds(newSelectedIds)
    props.onSelectValue(newSelectedIds)
  }
  return (
    <SafeAreaView edges={['left', 'right', 'bottom']} style={styles.root}>
      <View style={styles.container}>
        <FlatList
          style={styles.list}
          data={props.values}
          contentContainerStyle={styles.listContentContainer}
          keyExtractor={item => String(item.id)}
          renderItem={({ item }) => (
            <ValueRow
              value={item}
              selected={selectedIds.includes(item.id)}
              onPress={() => onSelectValue(item)}
            />
          )}
        />
      </View>
    </SafeAreaView>
  )
}

interface ValueRowProps {
  value: SettingValue
  selected: boolean
  onPress(): void
}

function ValueRow({ value, selected, onPress }: ValueRowProps) {
  const styles = useStyles()
  return (
    <PressableOpacity onPress={onPress} disabled={value.locked}>
      <ListItem disabled={value.locked} containerStyle={styles.listItem}>
        <ListItem.Content>
          <ListItem.Title style={value.locked && styles.listItemTitleLocked}>
            {value.name}
          </ListItem.Title>
        </ListItem.Content>
        <CheckBox
          checked={selected}
          disabled={value.locked}
          onPress={onPress}
        />
      </ListItem>
    </PressableOpacity>
  )
}

const useStyles = makeStyles(theme => ({
  root: {
    flex: 1,
  },
  container: {
    flex: 1,
    marginHorizontal: 0,
    paddingHorizontal: 0,
  },

  list: {
    paddingVertical: 10,
  },

  listItem: {
    marginVertical: 8,
  },
  listItemTitleLocked: {
    color: theme.colors?.grey4,
  },
  listContentContainer: {
    flexGrow: 1,
  },
}))
